export const SET_DEPOSIT_AMOUNT = 'SET_DEPOSIT_AMOUNT';
export const SET_PLATFORM_USAGE_FEE_PERCENTAGE = 'SET_PLATFORM_USAGE_FEE_PERCENTAGE';
